var map = {
	"./html": 386,
	"./html.js": 386,
	"./json": 387,
	"./json.js": 387,
	"./md": 388,
	"./md.js": 388,
	"./toml": 395,
	"./toml.js": 395,
	"./yaml": 397,
	"./yaml.js": 397
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 385;



/*****************
 ** WEBPACK FOOTER
 ** ../wrappers ^\.\/.*$
 ** module id = 385
 ** module chunks = 0
 **/